import React from 'react';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { SectionHeader } from '../shared/section-header/section-header';
import { B2C_ACCOUNT_PRIVACY_SECURITY, B2C_CLOSE_ACCOUNT, } from '../../constants/links';
import { setProfileAccountClosureLinksAnalytics } from '../../utils/profile-page-analytics';
var handleAccountClosureLinks = function (profilePageAccountClosureLink) {
    setProfileAccountClosureLinksAnalytics(profilePageAccountClosureLink);
};
export var AccountClosure = function () {
    var link = (React.createElement(Link, { href: B2C_CLOSE_ACCOUNT, onClick: function () { return handleAccountClosureLinks('close account link'); }, "data-testid": "profile-page-close-account-link" }, "Close Account"));
    return (React.createElement("div", null,
        React.createElement(SectionHeader, { title: "ACCOUNT CLOSURE" }),
        React.createElement(Typography, { variant: "body-base", weight: "regular" },
            link,
            React.createElement("div", { className: "sui-mt-8" },
                "Closing this account will not delete your personal information that was collected, but you can submit a request to access and delete your information.",
                ' ',
                React.createElement(Link, { href: B2C_ACCOUNT_PRIVACY_SECURITY, onClick: function () {
                        return handleAccountClosureLinks('close account privacy rights link');
                    }, "data-testid": "profile-page-privacy-link" }, "Exercise your privacy rights"),
                "."))));
};
